module.exports = __webpack_public_path__ + "img/pdf_logo.394c2041.png";